import { useDocTitle } from "@/hooks";
import { Outlet, useRouterState } from "@tanstack/react-router";
import { useEffect, Fragment } from "react";
import { TanStackRouterDevelopmentTools } from "../developmentTools";

export function RootComponent() {
  useDocTitle();
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <Fragment>
      <Outlet />
      <TanStackRouterDevelopmentTools
        position="bottom-left"
        initialIsOpen={false}
      />
    </Fragment>
  );
}
